<template>
	<div class="box">
    <div class="box_height">
      <img src="../assets/wxc-img.jpg" alt="" class="img_icon">
<!--      <img src="https://jgcx-online.oss-cn-zhangjiakou.aliyuncs.com/hh/automobile.jpg" alt="" class="img_icon">-->
<!--      <img v-show="locationShow" src="../assets/img/automobile_buttom.png" alt="" class="automobile_buttom">-->
<!--      <div class="box_page" v-show="locationShow">-->
<!--        <p class="box_page_title"><span style="font-family: 'BMWTypeNextLatin-Regular';">BMW</span><span style="font-family: 'HYZhongJianHeiJ';">预约停车充电</span></p>-->
<!--        <span class="box_page_introduce">预约停车充电一体化的专属尊贵服务</span>-->
<!--      </div>-->
<!--      <span v-show="locationShow" class="buttom_introduce">*图内墙盒仅做示意用图</span>-->
      <img v-show="locationShow" src="../assets/img/automobile_btn.png" alt="" id="submitLogin" @click="onUserLogin">
    </div>
	</div>
</template>
<script>
	export default {
		name: "wxchome",
		data() {
			return {
				locationShow: false
			}
		},
		mounted() {
			setTimeout(() => {
				this.topAndButtom()
			}, 1000)
		},
		created() {
			let lang = this.getQueryString("lang") || "zh_CN";
			localStorage.setItem("lang", lang);
			this.$i18n.locale = lang;

			let c = this.getQueryString(("c")) || '';
			if (c) {
				sessionStorage.setItem("c", c);
			}
		},
		methods: {
			topAndButtom() {

        let width = 750; //原图片大小
        let height = 1381; // 原图片大小

        var winWidth = document.querySelector('.box').clientWidth - 100;  // 浏览器可视部分宽度
        var winHeight = document.querySelector('.box').clientHeight - 80;  // 浏览器可视部分高度
        if (winWidth/ winHeight > width / height) {
          width = winHeight  * (width / height);
          document.querySelector('.box_height').style.width = width+'px'
        }
        let boxH = document.querySelector('.img_icon').clientHeight
        document.querySelector('.box_height').style.height = boxH+'px'

        // document.getElementById('submitLogin').style.bottom = (161/16)+'rem'
        // document.querySelector('.automobile_buttom').style.bottom = (62/16)+'rem'
        // document.querySelector('.buttom_introduce').style.bottom = (117/16)+'rem'
        this.locationShow = true
			},
			getQueryString(name) {
				let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				let r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);
				return null;
			},
			onUserLogin() {
				this.$router.push("/Login")
			}
		},
	}
</script>

<style>
	.box {
		width: 100%;
		height: 100%;
		background: #03132d;
		overflow: hidden;
	}
  .box_height{
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
    left: 50%;
    transform: translate(-50%,0);
  }
	.img_icon {
		width: 100%;
    max-width: 750px;
		position: absolute;
		left: 0;
		top: 0;
		display: block;
		image-rendering: pixelated;
		transform: translate(0, 0);
	}

	.box_page {
		width: 80%;
		position: absolute;
		left: 50%;
    transform: translate(-50%,0);
		box-sizing: border-box;
		top: 8.3125rem!important
	}

	.box_page_title {
		display: block;
		font-size: 2rem;
		margin-bottom: 0rem;
		color: white;
		letter-spacing: 1px;
		font-family: '黑体';
	}

	.box_page_introduce {
		display: block;
		font-size: 0.6rem;
		color: white;
		letter-spacing: 1px;
		font-family: 'hyzdxj';
    margin-top: 5px;
	}

	.buttom_introduce {
		position: absolute;
		left: 3.9375rem;
		font-size: 0.5rem;
		color: white;
		letter-spacing: 1px;
		font-family: 'hyzdxj';
	}

	.automobile_buttom {
		position: absolute;
		width: 65%;
		right: 3.9375rem;
		image-rendering: pixelated;
	}

	#submitLogin {
		width: 70%;
		line-height: 35px;
		font-size: 18px;
		position: absolute;
    left: 50%;
    bottom: 16vh;
    z-index: 666;
    transform: translate(-50%,0);
		border: 0;
	}
</style>
